import React, { createContext, useContext, useState } from 'react';
import { useAuth } from '../components/User/AuthContext';
import AdminEditToolbar from '../components/Admin/AdminEditToolbar';

const AdminEditContext = createContext({
  isAdmin: false,
  isEditing: false,
  editMode: true,
  setEditMode: () => {},
});

export function AdminEditProvider({ children }) {
  const { isAdmin } = useAuth();
  const [editMode, setEditMode] = useState(true);
  const isEditing = Boolean(isAdmin && editMode);

  return (
    <AdminEditContext.Provider value={{ isAdmin, isEditing, editMode, setEditMode }}>
      {children}
      {isAdmin && <AdminEditToolbar editMode={editMode} setEditMode={setEditMode} />}
    </AdminEditContext.Provider>
  );
}

export function useAdminEdit() {
  return useContext(AdminEditContext);
}
